export enum DocumentsCreateNewFolderMutationTypes {
  SET_IS_OPEN = 'SET_IS_OPEN',
  SET_LOADING = 'SET_LOADING',
}